//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SearchNoResults',
  methods: {
    reset () {
      this.$Search.softResetAllAttributes()
      this.$Search.search()
    }
  }
}
